<div *ngIf="isSingleChild() else children">
  <app-sorting-list *ngFor="let block of specialBlock.children" [typBlock]="0" [keyBlock]="keyBlock"
                    [specialBlock]="block" app-sorting-list
                    [class]="block.uId">
  </app-sorting-list>
</div>
<ng-template #children>
  <app-sorting-list *ngFor="let block of specialBlock.children" [typBlock]="53" [keyBlock]="keyBlock"
                    [viewPartBlock]="specialBlock?.settings?.viewPart" [stylsParentBlock]="specialBlock"
                    [specialBlock]="block"
                    app-sorting-list [class]="parseStyle(block)">
  </app-sorting-list>
</ng-template>
<ng-container [ngSwitch]="specialBlock.node">
  <ng-container *ngSwitchCase="blockNodeEnum.PARAGRAPH_NODE">
    <div *ngIf="viewPartBlock === 'sortingContent1-1'" class="blockText" [class]="specialBlock?.uId">
      <p>{{ globalService.optionSelect[this.viewName] | translate }}</p>
    </div>
    <div *ngIf="viewPartBlock === 'sortingContent1'">

      <div [class]="stylsParentBlock?.uId" class="sortOptions" *ngFor="let option of sortOptions"
           (click)="onSelectChange(option)" (keydown.enter)="onSelectChange(option)">
        <div [class]="specialBlock?.uId" [value]="option.value">
          {{ option.label | translate }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.ICON_NODE">
    <div [item]="specialBlock" app-link classname="text-link" (click)="openOptions()" [class]="specialBlock?.uId"
         style="cursor: pointer;">
      <mat-icon [class]="specialBlock?.uId" style="width: 100%; height: 100%">{{ this.specialBlock.content }}</mat-icon>
    </div>
  </ng-container>
</ng-container>
